<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 16a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0 0a6.97 6.97 0 0 0 4-1.255m0 .505v5.382a1 1 0 0 1-1.447.894l-2.106-1.053a1 1 0 0 0-.894 0l-2.106 1.053A1 1 0 0 1 8 20.632V15.25"
      stroke="currentColor"
    stroke-linejoin="round"
    stroke-width="2"
    />
  </svg>
</template>

<script lang="ts" setup>
import type { IconProps } from '../types.js'

withDefaults(
  defineProps<IconProps>(),
  {
    size: 20,
  }
)
</script>
